module.exports = __webpack_public_path__ + "img/logo_constalica.297617ac.png";